import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Icon from '../../icon/icon.component';
import { getScreenSize, getCenter } from '../../utils/sizes';
import CTAShader from '../../shaders/cta.shader';
import {
  defaultContext,
  getInitialStyle,
  getFocusedStyle,
  getUnFocusedStyle,
  getProgressStyle,
} from './callToAction.style';
import { ICON_WIDTH, ICON_HEIGHT, PADDING, ICON_PADDING_LEFT, DEFAULT_BUTTON_WIDTH } from './callToAction.constants';

/**
 * CallToAction are used to navigate through a catalogue exploration.
 *
 * @version 2.7.9
 * @see https://zeroheight.com/726d5c282/p/994bae-calltoaction--v279
 */
export class CallToAction extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          shader: {
            type: CTAShader,
          },
        },
        Icon: {
          type: Icon,
        },
        Label: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._hasIcon = false;
    this._isFocused = false;
  }

  _attach() {
    const label = this.tag('Label');
    const icon = this.tag('Icon');

    const handleUpdate = () => {
      const { screenSize } = this._style;
      const iconWidth = this._hasIcon ? ICON_WIDTH[screenSize] : 0;
      const iconPaddingLeft = ICON_PADDING_LEFT[screenSize];
      let padding = PADDING[screenSize];

      let size = padding * 2 + label.finalW;
      let offset = iconWidth ? iconPaddingLeft + iconWidth : 0;
      let offsetX = padding + offset;

      if (label.finalW === 0) {
        size = DEFAULT_BUTTON_WIDTH[screenSize];
        padding = getCenter(DEFAULT_BUTTON_WIDTH[screenSize], iconWidth);
        offset = 0;
        offsetX = 0;
      }
      const w = size + offset;

      this.patch({
        w,
        Icon: {
          x: padding,
        },
        Label: {
          x: offsetX,
        },
      });
    };

    icon.on('txLoaded', handleUpdate);
    label.on('txLoaded', handleUpdate);
  }

  _detach() {
    this.tag('Label').removeAllListeners('txLoaded');
    this.tag('Icon').removeAllListeners('txLoaded');
  }

  set label(value) {
    this.tag('Label').text.text = value;
  }

  set picto(value) {
    const screenSize = getScreenSize();
    this._hasIcon = Boolean(value);

    this.tag('Icon').iconData = {
      picto: value,
      viewBox: {
        w: ICON_WIDTH[screenSize],
        h: ICON_HEIGHT[screenSize],
      },
    };
  }

  get progress() {
    return this._progress;
  }

  set progress(value) {
    if (this._progress === value) {
      return;
    }

    if (Number.isFinite(value)) {
      if (!Number.isFinite(this._progress)) {
        this.patch(getProgressStyle(this._style));
      }

      this.tag('Background').shader.progress = value;
    } else {
      if (Number.isFinite(this._progress)) {
        this.patch(getInitialStyle(this._style));
      }

      this.patch(this._isFocused ? getFocusedStyle(this._style) : getUnFocusedStyle(this._style));
    }

    this._progress = value;
  }

  _focus() {
    this._isFocused = true;
    if (Number.isFinite(this._progress)) {
      this.patch(getProgressStyle(this._style));

      return;
    }

    this.patch(getFocusedStyle(this._style));
  }

  _unfocus() {
    this._isFocused = false;
    if (Number.isFinite(this._progress)) {
      this.patch(getProgressStyle(this._style));

      return;
    }
    this.patch(getUnFocusedStyle(this._style));
  }
}
